import axios from "axios";
import Swal from "sweetalert2";


const serverURL = "http://localhost:5000";

async function getData(url) {
  try {
    const config = {
      headers: {

        Authorization: `${localStorage.getItem("Token")}`,
      },
    };
    const response = await axios.get(`${serverURL}/${url}`, config);
    return response.data;
  } catch (e) {
  console.error(e);
  Swal.fire({
    icon: "error",
    title: "Session Expired",
    text: "Please log in again.",
    confirmButtonColor: "#3085d6",
  });
  return { data: null, error: "Session has expired. Please log in again." };
}


  }


async function postData(url, body) {



  try {
    const config = {
      headers: {
  
        Authorization: `${localStorage.getItem("Token")}`,
      },
    };
    const response = await axios.post(`${serverURL}/${url}`, body, config);
    return response.data;
  }catch (e) {
  console.error(e);
  Swal.fire({
    icon: "error",
    title: "Session Expired",
    text: "Please log in again.",
    confirmButtonColor: "#3085d6",
  });
  return { data: null, error: "Session has expired. Please log in again." };
}


}

function getDate() {
  const cd = new Date();
  return `${cd.getFullYear()}/${cd.getMonth() + 1}/${cd.getDate()}`;
}

function getTime() {
  const cd = new Date();
  return `${cd.getHours()}:${cd.getMinutes()}:${cd.getSeconds()}`;
}






export { getData, postData, serverURL, getDate, getTime };
